import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Chip, { ChipStatusEnum } from "@/components/customComponents/Chip";
import ArrowLeft from "../assets/icon/svgs/ArrowLeft.svg?react";
import TabBar from "@/components/tabBar/TabBar";
import { Loader } from "@/assets/icon/loader";
import Plus from "../assets/icon/svgs/Plus.svg?react";
import Edit from "../assets/icon/svgs/Edit.svg?react";
import SimpleArrow from "../assets/icon/svgs/ArrowSimple.svg?react";
import CrossRight from "../assets/icon/svgs/CrossRight.svg?react";
import File from "../assets/icon/svgs/File.svg?react";
import { useTranslation } from "react-i18next";
import HeaderCommon from "@/components/header/HeaderCommon";
import { Button } from "@/components/ui/button";
import { PopUpAddAndEditProject } from "@/components/pop-ups/PopUpAddAndEditProject";
import HouseManagerApi, {
  GetRepairWorksResponse,
  RepairWork,
} from "@/api-client/api/services/houseManager/houseManager";
import Pagination from "@/components/customComponents/Pagination";
// import File from "../assets/icon/svgs/File.svg?react";
import { HOUSE_MANAGER } from "@/lib/constants/routes";
import SelectTab from "@/components/selectTab/SelectTab";
const ProjectsAndRepairWorks: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();

  const buildingId = searchParams.get("building_id");
  const apartmentName = searchParams.get("apartment_name");
  const [loading] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [repairWorks, setRepairWorks] = useState<GetRepairWorksResponse>();

  const [year, setYear] = useState<string | undefined>(undefined);
  const [status, setStatus] = useState<string | undefined>(undefined);

  const yearOptions = [
    { value: "2026", label: "2026" },
    { value: "2025", label: "2025" },
    { value: "2024", label: "2024" },
    { value: "2023", label: "2023" },
  ];

  const statusOptions = [
    { value: "planned", label: t("planned") },
    { value: "in_progress", label: t("in_progress") },
    { value: "done", label: t("done") },
    { value: "canceled", label: t("canceled") },
  ];

  const getRepairWorks = async () => {
    try {
      const response = await HouseManagerApi.getRepairWorks({
        building_id: buildingId || undefined,
        page: page,
        page_size: pageSize,
        year: year,
        status: status,
      });
      setRepairWorks(response);
      setTotalPages(response.pagination.total_pages);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getRepairWorks();
  }, [buildingId, page, pageSize, year, status]);

  const handleNavBack = () => {
    navigate(HOUSE_MANAGER);
  };

  const ststusStyle = (status: string) => {
    switch (status) {
      case "planned":
        return ChipStatusEnum.BLUE;
      case "done":
        return ChipStatusEnum.GREY;
      case "canceled":
        return ChipStatusEnum.RED;
      case "in_progress":
        return ChipStatusEnum.BLUE;
      default:
        return ChipStatusEnum.GREY;
    }
  };

  const options = {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  };

  const formatted = (dateStr: string) => {
    const date = new Date(dateStr);
    //@ts-expect-error options is not defined
    const datePart = new Intl.DateTimeFormat("en-US", options)
      .format(date)
      .replace(",", "");
    const timePart = date
      .toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      })
      .replace(" AM", "")
      .replace(" PM", "");
    return `${datePart}, at ${timePart}`;
  };

  const ProjectItem = ({
    item,
    index,
  }: {
    item: RepairWork;
    index: number;
  }) => {
    const [expandedItems, setExpandedItems] = useState<number[]>([]);

    const toggleExpand = (index: number) => {
      setExpandedItems((prev) =>
        prev.includes(index)
          ? prev.filter((i) => i !== index)
          : [...prev, index]
      );
    };
    return (
      <>
        <div className="flex flex-col gap-8">
          <div>
            <div className="flex flex-col gap-2">
              <div className="flex justify-between">
                <div className="flex flex-row gap-4 items-start">
                  <Chip
                    status={ststusStyle(item.status)}
                    text={t(`${item.status}`)}
                  />
                  <span className="text-[15px] text-[#00000080] font-medium">
                    {formatted(item.created_at)}
                  </span>
                </div>
                <div>
                  <PopUpAddAndEditProject
                    trigger={
                      <Button
                        className="flex flex-row gap-1 text-[20px] text-[#0027CB] px-0 leading-[130%] h-fit"
                        variant="link"
                        size="sm"
                      >
                        <Edit width={24} height={24} />
                        {t("projects_and_repair_works.edit_project")}
                      </Button>
                    }
                    building_id={buildingId ? parseInt(buildingId) : null}
                    fetchTenantRelationships={getRepairWorks}
                    item={item}
                  />
                </div>
              </div>
              <span className="text-[28px] font-medium leading-[130%]">
                {item.title}
              </span>
            </div>
            <div
              className={`flex flex-col w-[50%] gap-4 overflow-hidden ${
                expandedItems.includes(index) ? "max-h-full" : "max-h-[267px]"
              }`}
            >
              <div
                className={` rich-text-view `}
                dangerouslySetInnerHTML={{ __html: item.description }}
              />
              <div className="flex flex-wrap gap-[20px]">
                {item.files.map((file) => {
                  return (
                    <a
                      href={file.pdf}
                      className="flex flex-row gap-2 text-[#0027CB] text-[20px] font-medium items-center"
                    >
                      <File width={24} height={24} />
                      <span>{file.pdf?.split("/").pop()}</span>
                    </a>
                  );
                })}
              </div>
            </div>
          </div>
          <div>
            <Button
              className="flex flex-row gap-2 leading-[120%] text-[20px] text-[#0027CB] h-fit px-0 items-center"
              variant="link"
              size="sm"
              onClick={() => toggleExpand(index)}
            >
              {expandedItems.includes(index)
                ? t("projects_and_repair_works.read_less")
                : t("projects_and_repair_works.read_more")}
              <SimpleArrow
                width={18}
                height={18}
                className={`transition-transform ${
                  expandedItems.includes(index) ? "" : "rotate-180"
                }`}
              />
            </Button>
          </div>
        </div>
        {repairWorks?.results.length !== index + 1 && (
          <span className="border-b-[1px] border-[#0000001A]" />
        )}
      </>
    );
  };

  return (
    <div className="flex flex-row flex-1 p-4 gap-6">
      <TabBar />
      {loading ? (
        <div className="flex justify-center w-full h-full my-auto">
          <Loader isGrey={true} />
        </div>
      ) : (
        <div className="px-4 flex flex-col flex-1 gap-5">
          <div className="flex justify-between items-center">
            <div className="flex flex-row items-center gap-2 font-medium text-[20px]">
              <Button variant="link" size="sm" onClick={handleNavBack}>
                <ArrowLeft id="arrow_left" />
              </Button>
              <span>
                {t("projects_and_repair_works.projects_and_repair_works")}
              </span>
              - {apartmentName}
            </div>
            <HeaderCommon />
          </div>
          <div className="flex items-center justify-between">
            <div
              id="title_bills"
              className="flex items-center text-[24px] gap-2 font-medium"
            >
              {t("projects_and_repair_works.projects")}
              <span
                id="all_bills_paid_header"
                className={`px-2 rounded-[20px] text-[#00000080] text-[16px] bg-[#F5F5F5]`}
              >
                {repairWorks?.pagination.total_items}
              </span>
              <Chip
                status={ChipStatusEnum.BLUE}
                text={`${t("projects_and_repair_works.planned")} ${
                  repairWorks?.status_counts.planned
                }`}
              />
              <Chip
                status={ChipStatusEnum.BLUE}
                text={`${t("projects_and_repair_works.in_progress")} ${
                  repairWorks?.status_counts.in_progress
                }`}
              />
              <Chip
                status={ChipStatusEnum.GREY}
                text={`${t("projects_and_repair_works.done")} ${
                  repairWorks?.status_counts.done
                }`}
              />
              <Chip
                status={ChipStatusEnum.RED}
                text={`${t("projects_and_repair_works.canceled")} ${
                  repairWorks?.status_counts.canceled
                }`}
              />
            </div>
            <div className="flex flex-row gap-[24px] items-center">
              <SelectTab
                key={1}
                selectedTab={year || t("year")}
                setSelectedTab={(newValue: string) => {
                  setYear(newValue);
                }}
                tabs={yearOptions}
                titleLabel={t("house_manager.year")}
              />
              <SelectTab
                key={2}
                selectedTab={status || t("status")}
                setSelectedTab={(newValue: string) => {
                  setStatus(newValue);
                }}
                tabs={statusOptions}
                titleLabel={t("house_manager.status")}
              />
              <div
                className={`${
                  year || status
                    ? "text-[#0027CB] cursor-pointer"
                    : "text-[#00000033] cursor-not-allowed"
                } text-[17px] font-medium flex flex-row items-center`}
                onClick={() => {
                  if (year || status) {
                    setYear(undefined);
                    setStatus(undefined);
                  }
                }}
              >
                {t("house_manager.clean_filter")}{" "}
                <CrossRight className="w-[24px] h-[24px]" />
              </div>
              <PopUpAddAndEditProject
                trigger={
                  <Button
                    variant="system"
                    size="sm"
                    onClick={() => console.log("object")}
                    className="flex items-center w-fit h-fit gap-1 font-medium text-[20px] py-2 leading-[130%]"
                  >
                    <Plus className="w-6 h-6" />
                    <div>{t("projects_and_repair_works.add_project")}</div>
                  </Button>
                }
                building_id={buildingId ? parseInt(buildingId) : null}
                fetchTenantRelationships={getRepairWorks}
              />
            </div>
          </div>
          <div className="flex flex-col gap-[40px]">
            {repairWorks?.results.map((item, index) => {
              return <ProjectItem item={item} index={index} />;
            })}
          </div>

          <Pagination
            totalPages={totalPages}
            page={page}
            setPage={setPage}
            pageSize={pageSize}
            setPageSize={setPageSize}
            contentLength={repairWorks?.pagination.total_items || 0}
            storageKey="repairWorks"
          />
        </div>
      )}
    </div>
  );
};

export default ProjectsAndRepairWorks;
